import React from 'react'

interface GroupBadgeProps {
  groupName: string
  onRemove: () => void
}

const GroupBadge: React.FC<GroupBadgeProps> = ({ groupName, onRemove }) => {
  return (
    <div className="group-badge">
      <span className="group-badge__name">{groupName}</span>
      <button
        type="button"
        className="group-badge__remove"
        onClick={onRemove}
        aria-label="Remove group selection"
        title="Remove group selection"
      />
    </div>
  )
}

export default GroupBadge
